import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useContext, useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';

import { authContext } from '@staffedupusa/shared-components';
import { CongratsIcon } from '../../../../vectors/index';
import { track } from '@amplitude/analytics-browser';
import { amplitudeEventsName } from '@utils/amplitudeEvents';
import { useUpdateProfile } from '@features/profile/hooks/useUpdateProfile';

const CongratsOnHire = () => {
  const { authData } = useContext(authContext);
  const navigate = useNavigate();
  const companyPlan = authData?.user?.company?.plan;
  const isSmarter = companyPlan === 1 ? true : false;
  const isJobOfferAccepted =
    authData?.user?.company?.check_list?.job_offer_manual;
  const [openModal, setopenModal] = useState(true);
  const [isJobOfferAcceptedState, setIsJobOfferAcceptedState] = useState(false);

  const { updateProfile } = useUpdateProfile({});
  const handleNavigation = () => {
    track(
      isSmarter
        ? amplitudeEventsName.SUCCESSFUL_HIRE_SMARTER_ONBOARDING_BUTTON
        : amplitudeEventsName.SUCCESSFUL_HIRE_STARTER_POPUP_UPGRADE_BUTTON,
    );
    handleClose();
    navigate('/employer/account#Manage-Billing', {
      state: isSmarter ? { proPlan: true } : { smarterPlan: true },
    });
  };

  const titleText = isSmarter
    ? 'Congratulations on your hire! <br/><span style="display:inline-block; margin-top: 10px; font-size: 18px">Want to onboard your new hire in seconds?</span>'
    : 'Congratulations on your hire! <br/><span style="display:inline-block; margin-top: 10px; font-size: 18px">We promised it would be easy…</span>';

  const subtitle = isSmarter
    ? `Send new hire paperwork with one click, & get<br/> new hires on your schedule in a fraction of the time.<br/>   Available on the Pro Plan!`
    : `Want to make hiring effortless for all  your positions, forever?`;
  const bodyText = isSmarter
    ? `Upgrade to the Pro plan to hire for unlimited positions <br/> and never struggle to hire again.`
    : `Upgrade to the Smarter plan to hire for unlimited positions<br/>  and never struggle to hire again.`;
  const buttonText = isSmarter ? 'Turn on Digital Onboarding' : 'Upgrade Now';

  useEffect(() => {
    if (isJobOfferAccepted) {
      setIsJobOfferAcceptedState(true);
      setopenModal(true);
      updateProfile({ job_offer_manual: false });
    }
  }, []);

  const handleClose = () => {
    setopenModal(false);
  };

  if (!isJobOfferAcceptedState) return null;

  return (
    <Dialog open={openModal} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          textAlign: 'center',
          position: 'relative',
          px: 4,
          pt: 4,
          pb: 2,
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <CongratsIcon />

        <Typography
          variant="h3"
          mt={2}
          dangerouslySetInnerHTML={{ __html: titleText }}
        />

        <Typography
          variant="h6"
          textAlign="center"
          mt={1.5}
          lineHeight={1.4}
          fontSize={15}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', px: 4, pb: 4 }}>
        <Typography
          color="text.secondary"
          lineHeight={1.6}
          mb={3}
          fontSize={14}
          dangerouslySetInnerHTML={{ __html: bodyText }}
        />

        <Button onClick={handleNavigation} variant="contained" fullWidth>
          {buttonText}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default CongratsOnHire;
